import { PasswordPolicyCheckSkippedReason } from 'persistable-types';

import isPin from '../leakedPasswords/isPin';

export default function getPasswordPolicyCheckSkipReason(
  password: string,
): Exclude<PasswordPolicyCheckSkippedReason, PasswordPolicyCheckSkippedReason.unknown> | undefined {
  if (password === '') {
    return PasswordPolicyCheckSkippedReason.empty;
  }
  if (isPin(password)) {
    return PasswordPolicyCheckSkippedReason.pin;
  }
  return undefined;
}
